import React, { Component } from 'react';

const NewExit = () => {
	return ( <h1>New Exit</h1> );
}
 
export default NewExit;